import React from 'react'
import MonthlyRental from '../MontlyRentals/MontlyRental'
import MFilter from './MFilter'


function MontlyRentalComponent() {
  return (
    <>
    <h1 className="text-3xl font-semibold text-center text-[#FF9630] my-4">Monthly Rentals</h1>
    
    <div className="min-h-screen flex gap-8 p-12">
    {/* Left Side - Filter (1/3 width) */}
    <div className="w-1/3">
      <MFilter/>
    </div>

    <div className="w-4/5">
  <MonthlyRental/>
    </div>
  </div>
  </>
  )
}; 

export default MontlyRentalComponent